import React from 'react'; 
import { FunctionFactory } from 'survey-core';
import { Goals } from '../quiz/goals';

const goodHandsHtml = `
<div class="new-quote-container centered">
  <div class="splash-icon">💪</div>
  <div class="splash-header">
    <h1>You’re in good company!</h1>
    <div class="quote">
      110,247 people have {goodHandsGoalText} with this exact approach—now it’s your turn.
    </div>
  </div>
</div>`;

const goodHandsSplashElement = {
  name: 'good-hands-splash',
  type: 'html',
  html: goodHandsHtml,
}

function renderGoodHandsGoalsText(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (params[0] as Goals) {
    case Goals.LoseFat:
      return "lost weight"
    case Goals.BuildMuscle:
      return "built muscle";
    case Goals.BuildMuscleAndLoseFat:
      return "have lost weight and built muscle";
  }
}

const goodHandsGoalsTextExpression = {
  name: "goodHandsGoalText",
  expression: "renderGoodHandsGoalsText({goals})",
};

FunctionFactory.Instance.register("renderGoodHandsGoalsText", renderGoodHandsGoalsText);

const GoodHandsSplashHeader = () => {
  return (
    <div style={{
      padding: "8px 0 5px 0",
      background: "white",
      textAlign: "center",
      color: "#7A7A7A",
      fontSize: "12px",
    }}>
      🧠 Your answers are shaping your plan
    </div>
  )
}

export {
  goodHandsSplashElement,
  goodHandsGoalsTextExpression,
  GoodHandsSplashHeader,
}
